<template>
	<div class="p-10">
		<h1>{{ $t('templates') }}</h1>
		<el-card class="no-shadow">
			<templates-table> </templates-table>
		</el-card>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import TemplatesTable from '@/components/_Template/TemplatesTable';

export default {
	components: {
		TemplatesTable
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore'])
	}
};
</script>
